var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "25px",
    viewBox: "0 0 30 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B3EB7979-422E-470B-A4CE-31288CB17BEA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "10.0-Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.0-Dealer-Support-Dashboard",
    transform: "translate(-25.000000, -454.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav-main",
    transform: "translate(0.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(0.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(16.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_48/dummy-icon_48/forum"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-48"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0430814,17.1353183 L10.9569186,17.1353183 C10.5066326,17.1353183 10.1403189,17.4996369 10.1403189,17.9474703 L10.1403189,30.6865166 C10.1403189,31.13435 10.5078496,31.4986686 10.9569186,31.4986686 L12.2165024,31.4986686 L12.2165024,34.2110869 L14.6091031,31.4986686 L27.0430814,31.4986686 C27.4933674,31.4986686 27.8596811,31.13435 27.8596811,30.6865166 L27.8596811,17.9474703 C27.8596811,17.4996369 27.4933674,17.1353183 27.0430814,17.1353183 Z M11.8209809,36 C11.6311306,36 11.4510162,35.9297991 11.3122794,35.8015008 C11.1613728,35.6635197 11.0749665,35.4662309 11.0749665,35.2604696 L11.0749665,32.6339869 L10.9569186,32.6339869 C9.87866618,32.6339869 9,31.7601065 9,30.6865166 L9,17.9474703 C9,16.8738804 9.87866618,16 10.9569186,16 L27.0430814,16 C28.1237678,16 29,16.8738804 29,17.9474703 L29,30.6865166 C29,31.7601065 28.1225508,32.6339869 27.0430814,32.6339869 L15.1263235,32.6339869 L12.3783619,35.748245 C12.2371912,35.9092229 12.033954,36 11.8209809,36 Z M36.1778021,31 C35.96848,31 35.7664598,30.911649 35.6216381,30.7470499 L32.8736765,27.63177 L31.1090422,27.63177 L31.1090422,26.4977307 L33.3908969,26.4977307 L35.7834976,29.2099849 L35.7834976,26.4977307 L37.0430814,26.4977307 C37.4933674,26.4977307 37.8596811,26.1334342 37.8596811,25.6856278 L37.8596811,12.9461422 C37.8596811,12.4995461 37.4933674,12.1352496 37.0430814,12.1352496 L20.9569186,12.1352496 C20.5066326,12.1352496 20.1403189,12.4995461 20.1403189,12.9461422 L20.1403189,14.6139183 L19,14.6139183 L19,12.9461422 C19,11.8726172 19.8774492,11 20.9569186,11 L37.0430814,11 C38.1237678,11 39,11.8726172 39,12.9461422 L39,25.6856278 C39,26.7591528 38.1237678,27.63177 37.0430814,27.63177 L36.9250335,27.63177 L36.9250335,30.2593041 C36.9250335,30.570348 36.7364001,30.8426626 36.4431058,30.9515885 C36.3554825,30.9842663 36.2666423,31 36.1778021,31 Z M14,21.852 L14,21.148 L24,21.148 L24,21.852 L14,21.852 Z M14,23.852 L14,23.148 L24,23.148 L24,23.852 L14,23.852 Z M14,25.8515 L14,25.1485 L24,25.1485 L24,25.8515 L14,25.8515 Z M14,27.8515 L14,27.1485 L18,27.1485 L18,27.8515 L14,27.8515 Z",
    id: "Combined-Shape",
    fill: "#000000"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForum);
export default __webpack_public_path__ + "static/media/forum.5681ec8a887eeba3c93c0745b595e315.svg";
export { ForwardRef as ReactComponent };